
export const allowNumber = (value) => {
    const re = /^[0-9\b]+$/;
    return (value === '' || re.test(value));
}

export const allowNumberDecimal = (value) => {
    const re = /^\d*\.?\d*$/;
    return (value === '' || re.test(value));
}
